import React from "react";
import { seperator } from "../../../helperFunctions";
import { getStatusStyle } from "../../../theme";

const WithdrawalChargeBackTableDetails = (props) => {
  const { item } = props;
  const { bgClassName } = getStatusStyle(item?.withdrawalSts);

  return (
    <>
      <div className="d-flex tabmain"></div>
      <div className="mainbox">
        <div className="d-flex gap-1">
          <div className="box-style">
            <h5>
              <span>Bank Details</span>
            </h5>
            <div className="other-sec">
              <p>
                <b> A/c Name : </b> {item?.acHolderName || ""}
              </p>
              <p>
                <b> A/c No : </b> {item?.bankAc || ""}
              </p>
              <p>
                <b> Bank : </b> {item?.bankName || ""}
              </p>
              <p>
                <b> IFSC : </b> {item?.ifscCode || ""}
              </p>
              <p>
                <b>Customer City :</b> {item?.custCity}
              </p>
            </div>
          </div>
          <div className="box-style">
            <h5>
              <span> PG Details</span>
            </h5>
            <div className="other-sec">
              <p>
                <b>Label :</b>
                {item?.pgLabel || "-"}
              </p>
              <p>
                <b>Bank :</b>
                {item?.pgName || ""}
              </p>
              <p>
                <b>Meta Id :</b>
                {item?.bankId || ""}
              </p>
              <p>
                <b>Batch Id :</b>
                {item?.manualPayBatchId || ""}
              </p>
            </div>
          </div>

          <div className="box-style">
            <h5>
              <span> Other Detail</span>
            </h5>

            <div className="other-sec">
              <p>
                <b> Temp UTR : </b> {item?.tempBankRrn || ""}
              </p>
              <p>
                <b> PG Ref Id : </b> {item?.pgRefId || ""}
              </p>
              <p>
                <b> Assoc Fees : </b> {seperator(item?.associateFees)}
              </p>
              <p>
                <b> Withdrawal By : </b> {item?.withdrawalBy || ""}
              </p>
              <p>
                <b> Webhook : </b> {item?.isNotifyCalled || ""}
              </p>
              <p>
                <b> udf1 : </b> {item?.udf1 || ""}
              </p>
              <p style={{ whiteSpace: "pre-line" }}>
                <b className="text-red"> Des : </b> {item?.reason || ""}
              </p>
            </div>
          </div>
          <div className="box-style d-flex flex-column justify-content-end">
            <div>
              {item?.processBy ? <div
                className="bgDiv"
              >
                Update By : {item?.processBy}
              </div> : null}</div>
          </div>
        </div>

        <div className="amount-sec">
          <div className="amount-sub">
            <div>
              <p>Total Amount</p>
              <h4>{`${seperator(+item?.totalAmt)}`}</h4>
            </div>
            <div>
              <p>Withdrawal ID</p>
              <h6>{item?.withdrawalId}</h6>
            </div>
            <div>
              <p>UTR</p>
              <h6> {item?.bankRrn || "-"}</h6>
            </div>
            <div>
              <p>Status</p>
              <span className={`${bgClassName}`}>{item?.withdrawalSts}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WithdrawalChargeBackTableDetails;
